import React from "react";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
} from "@common-ui/ui";

// import { useHistory } from "react-router-dom";
import { getAvatarInitials } from "../../utils";

function displayCardMedia(asset) {
  let media = getAvatarInitials(asset.make);
  let objectFit = "cover";
  if (asset?.image_url) {
    media = asset?.image_url;
    objectFit = "contain";
  }
  return <CardMedia component="img" image={media} alt={asset.make} sx={{ height: 140, objectFit: objectFit }}/>
}

export const AssetCardView = (props) => {
  let { handleModal } = React.useContext(ModalContext);
  let data = props.rows;
  // let router = useHistory();
  const cardItem = (item) => (
    <Card
      sx={{ maxWidth: 345 }}
      onClick={() =>
        // router.push({
        //   pathname: `/customers/${item.system_id}/${item.orgId}`,
        // })
        handleModal("Coming Soon!", "Alert")
      }
    >
      <CardActionArea>
        {displayCardMedia(item)}
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {item.make}
          </Typography>
          <Typography
            sx={{ display: "inline" }}
            gutterBottom
            component="div"
            color="text.secondary"
            variant="body2"
          >
            Make: {item.make || "None"} <br />
          </Typography>
          <Typography
            sx={{ display: "inline" }}
            gutterBottom
            component="div"
            color="text.secondary"
            variant="body2"
          >
            Model: {item.model || "None"} <br />
          </Typography>
          <Typography
            sx={{ display: "inline" }}
            gutterBottom
            component="div"
            color="text.secondary"
            variant="body2"
          >
            Serial Number: {item.serial_number || "None"} <br />
          </Typography>{" "}
        </CardContent>
      </CardActionArea>
    </Card>
  );
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
        }}
      >
        <Grid container spacing={2}>
          {Array.from(data).map((dataItem, i) => {
            return (
              <Grid item key={i} xs={6} sm={4} md={3}>
                {cardItem(dataItem)}
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};
